<div class="screen">

    <!-- HEADER -->
    <div class="header">
    </div>
  
    <!-- HERO SECTION -->
    <div class="hero">
  
      <div class="circle">
  
        <img
          src="assets/processing.png"
          class="illustration"
          alt="warning"
        />
  
      </div>
  
    </div>
  
    <!-- TEXT -->
    <div class="text-block">
      <div class="title">Transfer in progress</div>
  
      <div class="subtitle">
        Were waiting for confirmation from 
        your bank. This can take upto 24 
        hours. 
        We'll notify you once your 
        money arrives. 
      </div>
    </div>
  
    <!-- BUTTON -->
    <footer class="screen-footer">
      <button
        pButton
        label="DONE"
        class="retry-btn"
        (click)="retry()"
      ></button>  
    </footer> 
    
  </div>
  